import React, { useCallback, useMemo } from "react"
import { Box, useTheme, Button } from "@mui/material"
import { useNavigate } from "react-router-dom"
import _ from "lodash"

import { MotionDiv } from "components/motions"
import { Head } from "components/Head"

import { useTranslation } from "providers/i18n"
import { useTaxiDetail } from "extensions/em-transportation/hooks/useTaxiDetail"
import { Image } from "components/Image"
import { TaxiIcon } from "components/icons"
import { useExtension } from "hooks/extension/useExtension"

export const EmTaxiTransportationMobilePage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { extensionConfig } = useExtension()
  const taxiConfig = useMemo(
    () => _.get(extensionConfig, "em-transportation.options"),
    [extensionConfig]
  )

  const taxiLocationLinks = useMemo(
    () => _.get(taxiConfig, "taxi.locations", []),
    [taxiConfig]
  )

  const { locationLinks } = useTaxiDetail(taxiLocationLinks, taxiConfig)

  const theme = useTheme()
  const taxiImage = useMemo(() => _.get(theme, "assets.taxi.url"), [theme])
  const styleOverrides =
    theme.components[`EmTaxiTransportationPage`]?.styleOverrides || {}
  const { root, image, imageContainer, locationButtons, button } =
    styleOverrides

  const onClickTaxiLocation = useCallback(
    (id) => {
      navigate(`/maps/place/${id}`)
    },
    [navigate]
  )

  return (
    <>
      <Head title={t("Transportation (Taxi)")} />
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        <Box sx={root}>
          <Box sx={imageContainer}>
            <Image sx={image} src={taxiImage} />
          </Box>
          <Box sx={locationButtons}>
            {locationLinks.map((data, index) => {
              const { id, location, name } = data
              return (
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<TaxiIcon />}
                  sx={button}
                  key={`${id}-${index}`}
                  onClick={() => onClickTaxiLocation(location?.id)}
                >
                  {t(name)}
                </Button>
              )
            })}
          </Box>
        </Box>
      </MotionDiv>
    </>
  )
}
